import React, { useState } from 'react';
import { Image, Dialog, ImageViewer } from 'antd-mobile';
import PhotoAddCaptureView from './PhotoAddCaptureView';

/**
 * 相机连拍
 */

interface MultiPhotoGalleryViewProps {
    photos: string[];
    onDelete?: (index: number) => void;
    onAddPhoto?: () => void;
    onNativeBurstCapture: () => void;
    maxDisplayCount?: number;
}

const MultiPhotoGalleryView: React.FC<MultiPhotoGalleryViewProps> = ({
    photos = [],
    onDelete,
    onAddPhoto,
    onNativeBurstCapture,
    maxDisplayCount = 6
}) => {
    const [viewingPhoto, setViewingPhoto] = useState<string | null>(null);
    const [isClosing, setIsClosing] = useState(false);

    const handleViewPhoto = (url: string) => {
        if (!viewingPhoto && !isClosing) {
            setViewingPhoto(url);
        }
    };

    const handleCloseViewer = () => {
        setIsClosing(true);
        setViewingPhoto(null);

        // 延迟重置 isClosing 状态，防止事件穿透
        setTimeout(() => {
            setIsClosing(false);
        }, 300);
    };

    const handleAddPhoto = () => {
        if (onAddPhoto) {
            onAddPhoto();
        }
    };

    // 计算需要显示的照片数量
    const actualPhotoCount = photos.length;
    const shouldShowSelector = actualPhotoCount < maxDisplayCount;
    return (
        <>
            <div className="grid grid-cols-3 gap-2">
                {/* 显示已有的照片 */}
                {photos.map((photo, index) => (
                    <div key={index} className="relative aspect-square rounded-lg overflow-hidden bg-gray-100 w-full">
                        <Image
                            src={photo}
                            alt={`Photo ${index + 1}`}
                            fit="cover"
                            className="w-full h-full object-cover rounded-lg"
                            onClick={() => handleViewPhoto(photo)}
                        />
                        {onDelete && (
                            <div className="absolute top-2 right-2 bg-black/60 px-2 py-1 rounded text-white">
                                <div
                                    className="absolute -top-2 -right-2 -bottom-2 -left-2 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDelete(index);
                                    }}
                                />
                                <span className="text-xs relative z-10">
                                    X
                                </span>
                            </div>
                        )}
                    </div>
                ))}

                {/* 显示照片添加按钮 */}
                {shouldShowSelector && (
                    <PhotoAddCaptureView 
                        onNativeBurstCapture={onNativeBurstCapture}
                    />
                )}
            </div>

            {/* 查看大图 */}
            {viewingPhoto && (
                <ImageViewer
                    image={viewingPhoto}
                    visible={true}
                    onClose={handleCloseViewer}
                    renderFooter={() => null}
                />
            )}
        </>
    );
};

export default MultiPhotoGalleryView;
